import { createBrowserRouter } from "react-router-dom";
import Blogs from "../Components/Blogs";
import ErrorPage from "../Components/ErrorPage";
import Home from "../Components/Home";
import QuizePage from "../Components/QuizePage";
import Statistic from "../Components/Statistic";
import Root from "../Root/Root";

export const router = createBrowserRouter([
    {
        path: '/',
        loader: async () => fetch('https://openapi.programming-hero.com/api/quiz'),
        element: <Root></Root>,
        children: [
            { path: '/', element: <Home></Home> },
            { path: '/topics', element: <Home></Home> },
            { path: '/statistics', element: <Statistic></Statistic> },
            { path: '/blogs', element: <Blogs></Blogs> },
        ]
    },
    {
        path: '/quiz/:id',
        loader: async ({ params }) => fetch(`https://openapi.programming-hero.com/api/quiz/${params.id}`),
        element: <QuizePage></QuizePage>
    },
    { path: '*', element: <ErrorPage></ErrorPage> }


])